import { Column, Entity, PrimaryColumn } from 'typeorm'

@Entity({ name: 'TDeviceCfg' })
export class TDeviceCfg {
  @PrimaryColumn({ unsigned: true })
  DEVCFG_ID: number

  @Column({ unsigned: true })
  DEVICE_ID: number

  @Column({ length: 24 })
  DEVICE_NAME: string

  @Column({ type: 'tinyint', unsigned: true })
  DEV_CFG_FLAGS: number

  @Column({ type: 'tinyint', unsigned: true })
  SNTS_FREQ: number

  @Column({ type: 'tinyint', unsigned: true })
  SCHD_FREQ: number

  @Column({ unsigned: true })
  FW_VERSION: number

  @Column({ type: 'tinyint', unsigned: true })
  COORD_TYPE: number

  @Column({ type: 'double' })
  COORD_NS_VALUE: number

  @Column({ type: 'double' })
  COORD_EW_VALUE: number

  @Column({ type: 'double' })
  COORD_Z_VALUE: number

  @Column({ length: 5 })
  COORD_GRIDZONE: string

  @Column({ length: 24 })
  SITE_NAME: string

  @Column({ length: 8 })
  SITE_CODE: string

  @Column({ length: 6 })
  DEV_PIN: string

  @Column({ type: 'tinyint', unsigned: true })
  DEV_APP: number

  @Column({ type: 'timestamp' })
  DATE_EFFECT: Date

  @Column({ type: 'timestamp' })
  DATE_CREATE: Date

  @Column({ type: 'timestamp' })
  DATE_UPDATE: Date
}
